/* LYVN Diwali offer ladder (product page) — countdown only.
   The diyas animate in CSS on a loop; nothing here reads the quantity or the cart. */
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function start(root) {
    if (root.__dwTimer) return;
    var end = Date.parse(root.getAttribute('data-end'));
    var el = {};
    ['d', 'h', 'm', 's'].forEach(function (k) { el[k] = root.querySelector('[data-dw-t="' + k + '"]'); });
    if (isNaN(end) || !el.d) return;
    function tick() {
      var t = Math.max(0, end - Date.now());
      el.d.textContent = pad(Math.floor(t / 864e5));
      el.h.textContent = pad(Math.floor(t % 864e5 / 36e5));
      el.m.textContent = pad(Math.floor(t % 36e5 / 6e4));
      el.s.textContent = pad(Math.floor(t % 6e4 / 1e3));
    }
    tick();
    root.__dwTimer = setInterval(tick, 1000);
  }

  function init() {
    document.querySelectorAll('[data-diwali-offers]').forEach(start);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  /* the theme swaps the product form on variant change */
  document.addEventListener('shopify:section:load', init);
})();